import AbstractChatMessage from './AbstractChatMessage'
import cloneDeep from 'lodash/cloneDeep'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class ImageChatMessage extends AbstractChatMessage {
  declare body: {
    name: string
    url: string | null
    size: number // in bytes
  }
  base64?: string

  constructor({ body, base64, ...data }: LX.ImageChatMessage & { base64?: string }) {
    super(data)
    Object.assign(
      this,
      cloneDeep({
        body: {
          name: body.name,
          url: body.url,
          size: Number(body.size),
        },
      })
    )
    this.base64 = base64
  }

  static fromServer(data: LX.ImageChatMessage) {
    return new ImageChatMessage(data)
  }

  getShortMessage() {
    return this.body.name
  }
}
